module.exports = __webpack_public_path__ + "static/finalspotify-7d9149845d065c62cb2f57da3db96f7a.pdf";